// extracted by mini-css-extract-plugin
export default {"cancelIcon":"GuestInfoField_cancelIcon__g-ZSG"};